export const getZoneUrlSplit = (path: string) => {
    return path.split('zone/');
}

export const getZoneGuid = (path: string) => {
    const zoneUrlSplit = getZoneUrlSplit(path);
    return zoneUrlSplit.length === 1 ? "" : zoneUrlSplit[1].slice(0, 36);
}